var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function HamburgerMenuIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("rect", { x: 3, y: 6, width: 18, height: 2, rx: 1, fill: "#2C2C2C" }),
        React.createElement("rect", { x: 3, y: 11, width: 18, height: 2, rx: 1, fill: "#2C2C2C" }),
        React.createElement("rect", { x: 3, y: 16, width: 18, height: 2, rx: 1, fill: "#2C2C2C" })));
}
export var HamburgerMenuIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: HamburgerMenuIconInner }, props))); };
//# sourceMappingURL=HamburgerMenuIcon.js.map